import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
//import { TranslateService } from '@ngx-translate/core';
import { SettingService } from 'src/app/shared/services/setting.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-terms-page',
    templateUrl: './terms-page.component.html',
    styleUrls: ['./terms-page.component.scss'],
    standalone: false
})
export class TermsLandingPageComponent implements OnInit {
    terms: string;
    lang: string;

  constructor(
    private route: ActivatedRoute,
    //public translateService: TranslateService,
    private router: Router,
    private settingService: SettingService,
    private translationService: TranslationService
  ) { }

  ngOnInit() {
    const language=this.route.snapshot.paramMap.get('language');
   
   
    if(language)
    {
        this.lang = language;
      if(language === 'en' || language ==='fr')
        {        
          this.translationService.setLanguage(language);          
        }
        else {
          this.router.navigate(['/terms'])
        }
    } else {
        this.translationService.getLanguage();
    }
    this.getTerms();
    
  }

  getTerms() {
    this.settingService.getSATerms(this.lang).subscribe(async terms => {
        this.terms = terms;
    });
  }

}